import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../state.service';
import {User} from '../../model/user.model';
import {TakeTruffle} from '../../model/takeTruffle.model';

@Component({
    selector: 'app-add-truffle',
    templateUrl: './take-truffle.component.html',
    styleUrls: ['./take-truffle.component.css'],
    standalone: false
})
export class TakeTruffleComponent {
  takeTruffle = new TakeTruffle();
  submitted = false;
  user: User;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.user) {
      this.router.navigate( ['user']);
    }
    this.user = this.stateService.user;
  }

  onSubmit() {
    this.submitted = true;
    if (!this.user.takeTruffle) {
      this.user.takeTruffle = [];
    }
    this.user.takeTruffle.push(this.takeTruffle);
    this.stateService.editUser(this.user);
    this.router.navigate(['home/userId/' + this.user.id]);
  }
}
